import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-409ca595"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-inline-block" }
const _hoisted_2 = { class: "hiring-only-order-button" }

import ToggleButton from "@/components/atoms/button/ToggleButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HiringOnlyOrderButton',
  props: {
  hiringOnly: {
    type: Boolean,
    default: false
  }
},
  emits: ["toggle-hiring-only"],
  setup(__props, { emit: emits }) {





const onToggleHiringOnly = () => {
  emits("toggle-hiring-only");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode("\n      募集中のお仕事のみ表示\n      "),
      _createVNode(ToggleButton, {
        checked: __props.hiringOnly,
        onClick: onToggleHiringOnly
      }, null, 8, ["checked"])
    ])
  ]))
}
}

})